import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { Button } from '../components/ui/button';
export function Login() {
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/home');
  };
  return <div className="min-h-screen flex items-center justify-center p-4 bg-[#1AA0DB]" data-id="element-1021">
      <div className="bg-card w-full max-w-md rounded-lg shadow-xl p-8 md:p-10" data-id="element-1022">
        <div className="text-center mb-8" data-id="element-1023">
          <div className="flex justify-center items-center mb-4" data-id="element-1024">
            <img src="https://cdn.magicpatterns.com/uploads/s2MFPhMtmvBfy6H1KoBtds/Unione_Comunita_Ebraiche_Italiane_-_logo_(Italy).svg" alt="UCEI — Unione delle Comunità Ebraiche Italiane" className="h-16 w-auto object-contain" data-id="element-1025" />
          </div>
          <p className="text-muted-foreground" data-id="element-1026">
            Media Intelligence · Accedi alla piattaforma
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-5" data-id="element-1027">
          <div className="space-y-2" data-id="element-1028">
            <label htmlFor="email" className="text-sm font-medium text-foreground" data-id="element-1029">
              Email
            </label>
            <input id="email" type="email" placeholder="nome@ucei.it" className="w-full px-4 py-2.5 rounded-md border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-accent/50 transition-shadow" required data-id="element-1030" />
          </div>

          <div className="space-y-2" data-id="element-1031">
            <label htmlFor="password" className="text-sm font-medium text-foreground" data-id="element-1032">
              Password
            </label>
            <input id="password" type="password" placeholder="••••••••" className="w-full px-4 py-2.5 rounded-md border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-accent/50 transition-shadow" required data-id="element-1033" />
          </div>

          <Button type="submit" className="w-full rounded-full h-11 text-base" data-id="element-1034">
            Accedi
          </Button>
        </form>

        <div className="my-6 flex items-center" data-id="element-1035">
          <div className="flex-1 border-t border-border" data-id="element-1036"></div>
          <span className="px-4 text-sm text-muted-foreground" data-id="element-1037">oppure</span>
          <div className="flex-1 border-t border-border" data-id="element-1038"></div>
        </div>

        <Button variant="outline" type="button" onClick={() => navigate('/home')} className="w-full rounded-full h-11 text-base border-border hover:bg-muted/50" data-id="element-1039">
          <Shield className="h-4 w-4 mr-2" data-id="element-1040" />
          Accedi con SSO aziendale
        </Button>

        <div className="mt-8 text-center" data-id="element-1041">
          <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-id="element-1042">
            Problemi di accesso? Contatta il supporto
          </a>
        </div>
      </div>
    </div>;
}